function globalReducer(state, action) {
  switch (action.type) {
    case 'SET_USER': {
      return {
        ...state,
        userObject: action.payload,
      };
    }
    case 'OPEN_AUTH_MODAL': {
      return {
        ...state,
        authModal: {
          state: true,
          ...action.payload,
        },
      };
    }
    case 'CLOSE_AUTH_MODAL': {
      return {
        ...state,
        authModal: {
          state: false,
          ...action.payload,
        },
      };
    }
    case 'OPEN_MODAL': {
      return {
        ...state,
        questionModal: {
          state: true,
          ...action.payload,
        },
      };
    }
    case 'CLOSE_MODAL': {
      return {
        ...state,
        questionModal: {
          state: false,
          ...action.payload,
        },
      };
    }
    case 'OPEN_LEAD_MAGNET_MODAL': {
      return {
        ...state,
        leadMagnetModal: {
          state: true,
          ...action.payload,
        },
      };
    }
    case 'CLOSE_LEAD_MAGNET_MODAL': {
      return {
        ...state,
        leadMagnetModal: {
          state: false,
          ...action.payload,
        },
      };
    }
    case 'EDITOR_PARAMS': {
      return {
        ...state,
        editorParams: action.payload,
      };
    }
    case 'OPEN_TEAM_INVITE_INFO_MODAL': {
      return {
        ...state,
        teamInviteInfoModal: { state: true },
      };
    }
    case 'CLOSE_TEAM_INVITE_INFO_MODAL': {
      return {
        ...state,
        teamInviteInfoModal: { state: false },
      };
    }
    case 'OPEN_TEAM_SELECTION_MODAL': {
      return {
        ...state,
        teamSelectionModal: { state: true, data: action.payload },
      };
    }
    case 'CLOSE_TEAM_SELECTION_MODAL': {
      return {
        ...state,
        teamSelectionModal: { state: false, data: null },
      };
    }
    case 'OPEN_PERSONA_MODAL': {
      return {
        ...state,
        personaModal: {
          state: true,
        },
      };
    }
    case 'CLOSE_PERSONA_MODAL': {
      return {
        ...state,
        personaModal: {
          state: false,
        },
      };
    }
    case 'OPEN_TEAM_INVITE_MODAL': {
      return {
        ...state,
        teamInviteModal: {
          state: true,
        },
      };
    }
    case 'CLOSE_TEAM_INVITE_MODAL': {
      return {
        ...state,
        teamInviteModal: {
          state: false,
        },
      };
    }
    case 'OPEN_ERROR_TOAST': {
      return {
        ...state,
        errorToast: { state: true, data: action.payload },
      };
    }
    case 'CLOSE_ERROR_TOAST': {
      return {
        ...state,
        errorToast: { state: false, data: null },
      };
    }
    default: {
      throw new Error(`Unknown Action Type: `, action.type);
    }
  }
}

export default globalReducer;
